module.exports = __webpack_public_path__ + "static/media/997678.6141243a.jpg";